import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { BeraV2Service } from '@/infra/services/bera-v2';

import type { BeraJobSummaryListPage, BeraJobSummaryListQuery } from '@/types/Bera';

export interface GetBeraJobSummaryListParams {
	organization_id: string;
	company_id: string;
	filter: BeraJobSummaryListQuery;
}

const Service = BeraV2Service.getInstance();

export function useGetBeraJobSummaryList(params: GetBeraJobSummaryListParams) {
	const enabled = validateUuid([params.organization_id, params.company_id]);

	return useQuery<BeraJobSummaryListPage>({
		queryKey: [QUERY_KEYS.GET_BERA_JOB_SUMMARY_LIST, params],
		queryFn: async () => Service.listJobSummaries(params),
		enabled
	});
}
